import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { useLanguage, translations } from '../context/LanguageContext';

const { FiGlobe } = FiIcons;

const LanguageSwitcher = () => {
  const { language, toggleLanguage } = useLanguage();
  const t = translations[language];

  return (
    <motion.button
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      onClick={toggleLanguage}
      className="fixed top-4 right-4 px-3 py-2 lg:px-4 lg:py-2 bg-white/10 backdrop-blur-md rounded-full border border-white/20 text-white hover:bg-white/20 transition-all duration-200 flex items-center space-x-2 z-50 text-sm lg:text-base"
    >
      <SafeIcon icon={FiGlobe} className="text-base lg:text-lg" />
      <span className="hidden sm:inline">{t.switchLanguage}</span>
    </motion.button>
  );
};

export default LanguageSwitcher;